import React, { useState, useEffect } from 'react';
import {
    View,
    SafeAreaView,
    Text,
    Image,
    StyleSheet,
    Dimensions,
    ScrollView,
    TouchableHighlight,
    TextInput,
    ImageBackground,
    ActivityIndicator,
    Keyboard
} from 'react-native';

import AsyncStorage from '@react-native-async-storage/async-storage';
import { authenticateApp } from '../../services/appAuth';
import { APP_SESSION_VERSION } from '../../config/api';

import logo from './assets/logo.png';
import backg from './assets/backg.jpg';

const screenWidth = Math.round(Dimensions.get('window').width);
const screenHeight = Math.round(Dimensions.get('window').height);

export const Login = ({ navigation }) => {

    const [windowDimensions, setWindowDimensions] = useState(Dimensions.get('window'));
    const [email, setEmail] = useState("");
    const [senha, setSenha] = useState("");
    const [erroValidador, setErroValidador] = useState("");
    const [erroValidador2, setErroValidador2] = useState("");
    const [loading, setLoading] = useState(false);

    function handleForgotPwd() {
        navigation.navigate('Esqueci');
    }

    async function checkStorage() {
        const version = await AsyncStorage.getItem('sfappauthversion');
        const userid = await AsyncStorage.getItem('sfuserid');
        if (version === APP_SESSION_VERSION && userid) {
            navigation.navigate('Home');
        } else if (userid) {
            // Sessões criadas no backend antigo precisam autenticar novamente.
            await AsyncStorage.clear();
        }
    }

    async function handleSubmit() {

        Keyboard.dismiss();

        if (email.trim() === '') {
            setErroValidador('preencha seu e-mail ou telefone');
            return;
        }

        setErroValidador('');

        if (senha === '') {
            setErroValidador2('preencha sua senha');
            return;
        }

        setErroValidador2('');
        setLoading(true);

        try {

            const data = await authenticateApp(email, senha);

            /*
             * Salva os dados utilizados pelo restante do aplicativo.
             */
            await AsyncStorage.setItem(
                'sfuseremail',
                String(email.trim())
            );

            await AsyncStorage.setItem(
                'sfusernome',
                String(data.nome ?? '')
            );

            await AsyncStorage.setItem(
                'sfuserid',
                String(data._id ?? '')
            );

            await AsyncStorage.setItem(
                'sfadmin',
                String(data.admin ?? false)
            );

            await AsyncStorage.setItem(
                'sfcomp',
                String(data.access_comp ?? false)
            );

            await AsyncStorage.setItem(
                'sfpit',
                String(data.access_pit ?? false)
            );

            await AsyncStorage.setItem(
                'sfrack',
                String(data.access_rack ?? false)
            );

            await AsyncStorage.setItem(
                'sfdesp',
                String(data.access_despesa ?? false)
            );

            await AsyncStorage.setItem(
                'sfdespappr',
                String(data.desp_appr ?? false)
            );

            await AsyncStorage.setItem(
                'sfcentrocusto',
                String(data.centro_custo ?? '')
            );

            await AsyncStorage.setItem('sfappauthversion', APP_SESSION_VERSION);
            await AsyncStorage.setItem('sfapp', 'true');
            navigation.navigate('Home');

        } catch (error) {

            setErroValidador2(
                error.message || 'Erro ao realizar login. Tente novamente.'
            );

        } finally {

            setLoading(false);
        }
    }

    useEffect(() => {

        checkStorage();

        const handleResize = ({ window }) => {
            setWindowDimensions(window);
        };

        const subscription = Dimensions.addEventListener(
            "change",
            handleResize
        );

        return () => {
            subscription.remove();
        };

    }, []);
    return (
      <SafeAreaView style={styles.container}>
        <ScrollView keyboardShouldPersistTaps="handled" contentContainerStyle={styles.page}>
          <Image source={logo} resizeMode="contain" style={styles.logo} />
          <Text style={styles.eyebrow}>PORTAL OPERACIONAL</Text>
          <View style={styles.card}>
            <Text style={styles.title}>Bem-vindo de volta</Text>
            <Text style={styles.subtitle}>Entre para acompanhar sua operação.</Text>
            <Text style={styles.label}>E-mail ou telefone</Text>
            <TextInput style={styles.input} autoCapitalize="none" autoCorrect={false}
              keyboardType="email-address" placeholder="Seu e-mail ou telefone" value={email}
              onChangeText={setEmail} autoComplete="username" accessibilityLabel="E-mail ou telefone" />
            {!!erroValidador && <Text style={styles.error} accessibilityLiveRegion="polite">{erroValidador}</Text>}
            <Text style={styles.label}>Senha</Text>
            <TextInput style={styles.input} autoCapitalize="none" autoCorrect={false}
              placeholder="Sua senha" secureTextEntry value={senha} onChangeText={setSenha}
              autoComplete="current-password" accessibilityLabel="Senha" returnKeyType="go" onSubmitEditing={() => !loading && handleSubmit()} />
            {!!erroValidador2 && <Text style={styles.error} accessibilityLiveRegion="polite">{erroValidador2}</Text>}
            <TouchableHighlight style={styles.forgot} underlayColor="#edf3fb" onPress={handleForgotPwd} accessibilityRole="button">
              <Text style={styles.forgotText}>Esqueci minha senha</Text>
            </TouchableHighlight>
            <TouchableHighlight disabled={loading} style={[styles.button, loading && { opacity: 0.7 }]}
              underlayColor="#00004C" onPress={handleSubmit} accessibilityRole="button">
              {loading ? <ActivityIndicator color="#fff" /> : <Text style={styles.buttonText}>Entrar</Text>}
            </TouchableHighlight>
          </View>
          <View style={styles.support}>
            <Text style={styles.supportTitle}>Precisa de acesso?</Text>
            <Text style={styles.supportText}>Fale com a equipe Super Frio</Text>
            <Text style={styles.supportText}>contato@superfriosr.com.br</Text>
            <Text style={styles.supportText}>(11) 4599-5239</Text>
          </View>
        </ScrollView>
      </SafeAreaView>
    );
};
const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#f4f7fb' },
  page: { flexGrow: 1, justifyContent: 'center', padding: 24, width: '100%', maxWidth: 480, alignSelf: 'center' },
  logo: { width: 190, height: 72, alignSelf: 'center', marginBottom: 10 },
  eyebrow: { color: '#5f7da1', fontSize: 10, letterSpacing: 2, fontWeight: '700', textAlign: 'center', marginBottom: 28 },
  card: { backgroundColor: '#fff', borderRadius: 24, padding: 24, borderColor: '#e1e8f2', borderWidth: 1 },
  title: { color: '#00004C', fontWeight: '700', fontSize: 24, marginBottom: 8 },
  subtitle: { color: '#63758c', fontSize: 14, lineHeight: 21, marginBottom: 28 },
  label: { color: '#00004C', fontWeight: '600', fontSize: 13, marginBottom: 8 },
  input: { minHeight: 52, width: '100%', backgroundColor: '#f7f9fc', borderRadius: 12, borderColor: '#d9e3f0', borderWidth: 1, paddingHorizontal: 14, fontSize: 16, color: '#172b4d', marginBottom: 16 },
  error: { color: '#a80101', fontSize: 13, marginBottom: 14, lineHeight: 19 },
  forgot: { alignSelf: 'flex-end', paddingVertical: 12, paddingHorizontal: 4, borderRadius: 8, marginBottom: 12 },
  forgotText: { fontSize: 13, fontWeight: '600', color: '#003c84' },
  button: { minHeight: 52, backgroundColor: '#003c84', alignItems: 'center', justifyContent: 'center', borderRadius: 12 },
  buttonText: { color: '#fff', fontSize: 16, fontWeight: '700' },
  support: { marginTop: 28, alignItems: 'center' },
  supportTitle: { color: '#00004C', fontWeight: '600', fontSize: 13, marginBottom: 6 },
  supportText: { color: '#63758c', fontSize: 12, lineHeight: 20 },
});
